module.exports = __webpack_public_path__ + "static/media/persona-1.31f5fcf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/persona-1.png
// module id = 575
// module chunks = 0